var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 38,
    viewBox: "0 0 79 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 77.5,
    height: 36.5,
    rx: 18.25,
    stroke: "#34B474",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3327 19.0013C27.3327 22.2229 24.721 24.8346 21.4993 24.8346C18.2777 24.8346 15.666 22.2229 15.666 19.0013C15.666 15.7796 18.2777 13.168 21.4993 13.168C24.721 13.168 27.3327 15.7796 27.3327 19.0013Z",
    stroke: "#34B474",
    strokeWidth: 2.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5007 7.33203V9.08203M21.5007 28.9154V30.6654M29.7499 27.2485L28.5124 26.0111M14.4881 11.9862L13.2507 10.7487M33.1673 18.9987H31.4173M11.584 18.9987H9.83398M29.7505 10.7489L28.513 11.9863M14.4887 26.0112L13.2513 27.2487",
    stroke: "#34B474",
    strokeWidth: 2.125,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5827 21.4261C67.183 22.1734 65.5845 22.5971 63.887 22.5971C58.3733 22.5971 53.9036 18.1274 53.9036 12.6136C53.9036 10.9161 54.3272 9.3176 55.0746 7.91797C50.1116 9.08111 46.416 13.5356 46.416 18.8533C46.416 25.0562 51.4445 30.0846 57.6474 30.0846C62.9651 30.0846 67.4195 26.3891 68.5827 21.4261Z",
    stroke: "#34B474",
    strokeOpacity: 0.25,
    strokeWidth: 2.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeLight);
export default __webpack_public_path__ + "static/media/mode-light.e8437ee983e21da137f0cdbff4572640.svg";
export { ForwardRef as ReactComponent };